const searchSuggestionData = [
  {
    integration: 'Microsoft Teams',
    link: '/integrations/microsoft-teams',
    logo: 'logo--microsoft-teams',
    logoWidth: 40,
    logoHeight: 40,
    description:
      'Get the latest call messages directly in your chosen channels.',
  },
  {
    integration: 'Zoho',
    link: '/integrations/zoho',
    logo: 'logo--zoho',
    logoWidth: 30,
    logoHeight: 30,
    description:
      'Automatically upload call data <br> into your Zoho CRM fields and cut out the middleman.',
  },
  {
    integration: 'Salesforce',
    link: '/integrations/salesforce',
    logo: 'logo--salesforce',
    logoWidth: 40,
    logoHeight: 40,
    description:
      'Seamlessly transfer call <br> information and qualified leads directly to your CRM.',
  },
  {
    integration: 'Hubspot',
    link: '/integrations/hubspot',
    logo: 'logo--hubspot',
    logoWidth: 30,
    logoHeight: 32,
    description:
      'Manage calls and categorise <br> leads directly in your dashboard.',
  },
  {
    integration: 'Zendesk',
    link: '/integrations/zendesk',
    logo: 'logo--zendesk',
    logoWidth: 40,
    logoHeight: 40,
    description:
      'Respond to caller inquiries <br> through one centralized channel.',
  },
  {
    integration: 'Slack',
    link: '/integrations/slack',
    logo: 'logo--slack',
    logoWidth: 40,
    logoHeight: 40,
    description:
      'Capture leads and share call info <br> in a click through your Slack <br> channels.',
  },
  {
    integration: 'Freshdesk',
    link: '/integrations/freshdesk',
    logo: 'logo--freshdesk',
    logoWidth: 40,
    logoHeight: 40,
    description:
      'Supercharge your sales process <br> by delivering a faster pipeline and a reduced workload.',
  },
  {
    integration: 'Mailchimp',
    link: '/integrations/mailchimp',
    logo: 'logo--mailchimp',
    logoWidth: 40,
    logoHeight: 40,
    description:
      'Drive engagement with your new customers by turning calls into personalised emails.',
  },

  {
    integration: 'Active Campaign',
    link: '/integrations/activecampaign',
    logo: 'logo--active-campaign',
    logoWidth: 40,
    logoHeight: 40,
    description:
      'Get more sales when your customer call data goes straight to your CRM platform.',
  },

  {
    integration: 'Constant Contact',
    link: '/integrations/constant-contact',
    logo: 'logo--constant-contact-new',
    logoWidth: 40,
    logoHeight: 40,
    description:
      'Turn callers into contacts and reach them with personalised emails, surveys and more.',
  },

  {
    integration: 'Setmore',
    link: '/integrations/setmore',
    logo: 'logo--setmore',
    logoWidth: 40,
    logoHeight: 40,
    description:
      'Manage, message and market to your customers, all from one place.',
  },
  {
    integration: 'Clio',
    link: '/integrations/clio',
    logo: 'logo--clio',
    logoWidth: 40,
    logoHeight: 40,
    description:
      'Follow up faster and grow your legal practice with latest legal leads in your CRM.',
  },
  {
    integration: 'Pipedrive',
    link: '/integrations/pipedrive',
    logo: 'logo--pipedrive-new',
    logoWidth: 40,
    logoHeight: 40,
    description:
      'Unlock more time, deliver a faster sales pipeline and reduce workloads.',
  },
  {
    integration: 'monday.com',
    link: '/integrations/monday',
    logo: 'logo--monday',
    logoWidth: 40,
    logoHeight: 40,
    description:
      'Keep your projects moving and your data clean around the clock.',
  },
  {
    integration: 'FreshSales',
    link: '/integrations/freshsales',
    logo: 'logo--freshsales',
    logoWidth: 40,
    logoHeight: 40,
    description:
      'Push caller contact information automatically to FreshSales and keep the sales flowing.',
  },
  {
    integration: 'Google Analytics',
    link: '/integrations/googleanalytics',
    logo: 'logo--google-analytics',
    logoWidth: 40,
    logoHeight: 40,
    description:
      'Collect call and chat data to<br> feed into your analytics.',
  },
  {
    integration: 'Google Sheets',
    link: '/integrations/googlesheets',
    logo: 'logo--google-sheets',
    logoWidth: 40,
    logoHeight: 40,
    description:
      'Collect call and chat data to<br> feed into your analytics.',
  },
  {
    integration: 'Zapier',
    link: '/integrations/zapier',
    logo: 'logo--zapier-new',
    logoWidth: 40,
    logoHeight: 40,
    description:
      'Plug into 400+ applications<br> and CRMs and set custom<br> triggers and events.',
  },
];

export default searchSuggestionData;
